<template>
	<v-card class="elevation-0 partners-page partners-page-container page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null" class="d-flex">
			<v-skeleton-loader
				v-if="boothStaffLoading"
				v-bind="attrs"
				width="600"
				type="list-item, list-item-three-line, card-heading"
			>
			</v-skeleton-loader>

			<div v-else style="width: 100%">
				<div class="agenda-page__title mt-0">Booth Staff</div>
				<FilterChipButton
					class="mt-4"
					:isButtonActive="isButtonActive"
					:chipsList="chipsList"
					:clearFilter="clearFilter"
					@handleChipClick="handleChipClick"
				/>
				<div v-if="filterModalIsVisible">
					<FilterModal
						:filterModalIsVisible="filterModalIsVisible"
						:currentModalFilter="currentModalFilter"
						:currentModalLabel="currentModalLabel"
						:selectedChips="selectedChips"
						:filters="filters"
						:dateError="date.error"
						:dateOption="date.option"
						:dateRange="date.selectedRange"
						@closeModal="closeModal"
						@applySelection="applySelection"
						@setItem="setItem"
					/>
				</div>
				<div class="boothStaff mt-5">
					<div v-for="(boothStaff, index) in boothStaffList" :key="index">
						<BoothStaffCard :boothStaff="boothStaff" backgroundColor="#fff" />
					</div>
				</div>

				<div
					v-if="!boothStaffLoading && boothStaffList.length > 0"
					class="d-flex my-9 justify-center home-page__pagination"
				>
					<Pagination
						:page="filters.page"
						:pageCount="+this.pageCountBoothStaff"
						v-on:pageChange="onPageChange"
					/>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import ButtonBack from '@/components/ButtonBack'
import Block from '@/mixins/Block.js'
import Filter from '@/mixins/Filter'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal.vue'
import BoothStaffCard from '@/components/Event/BoothStaffCard.vue'

export default {
	name: 'BoothStaffPage',
	mixins: [Block, Filter],
	components: {
		BoothStaffCard,
		FilterModal,
		FilterChipButton,
		PageBlocked,
		Pagination,
		ButtonBack,
	},

	methods: {
		...mapActions('event', ['getBoothStaff']),
	},

	created() {
		if (this.$route.params.id !== undefined && (!this.isBlocked || this.isBlocked === null)) {
			this.getBoothStaff(this.requestQuery)
		}
	},

	computed: {
		...mapGetters('event', ['boothStaffLoading', 'boothStaffList', 'pageCountBoothStaff']),
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
			},
			pageBlockedName: 'events',
		}
	},
}
</script>

<style lang="scss">
.partner-card-wrapper {
	display: flex;
	align-items: center;
	background: #fff;
	border: 1px solid #e2e2e2;
	border-radius: 8px;
	padding: 16px;
	cursor: pointer;
	text-decoration: none;

	&__link {
		display: flex;
		width: 100%;
		text-decoration: none;
	}

	.partner-card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;

		&__location-value {
			font-family: Montserrat, sans-serif;
			font-size: 13px;
			font-weight: 500;
			color: #4a4a4a;
		}

		&__logo {
			width: 64px;
			height: 64px;
			border-radius: 4px;
			overflow: hidden;
			margin-right: 16px;

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}

		&__info {
			flex: 1;

			&__title {
				font-family: Montserrat, sans-serif;
				font-weight: 700;
				font-size: 16px;
				color: #002855;
				margin-bottom: 4px;
			}

			&__subtitle {
				display: flex;
				align-items: center;
				font-family: Montserrat, sans-serif;
				font-size: 14px;
				color: #555;

				svg {
					margin-right: 8px;
				}
			}
		}
	}
}
</style>
